import { EnvironmentTypes, SiteConfig, footerApp, headerApp, shellApp } from '@openedx/frontend-base';
import customApp from './src/customApp';
import { addApp, addExternalRoute } from './src/utils';


import { authnApp } from '@openedx/frontend-app-authn';



import { learnerDashboardApp } from '@openedx/frontend-app-learner-dashboard';



import { instructorDashboardApp } from '@openedx/frontend-app-instructor-dashboard';



import { notificationsApp } from '@openedx/frontend-app-notifications';



import {
  createLegacyPluginApp,
  defaultRouteMap,
  defaultSlotMap,
  defaultWidgetMap,
} from '@openedx/frontend-base-compat';
import allEnvConfig from './src/env.config.all.jsx';
import instructorDashboardEnvConfig from './src/env.config.instructor-dashboard.jsx';
import notificationsEnvConfig from './src/env.config.notifications.jsx';

const routeMap = { ...defaultRouteMap, ...{} };
const slotMap = { ...defaultSlotMap, ...{} };
const widgetMap = { ...defaultWidgetMap, ...{} };





import '@openedx/frontend-base/shell/style';
import '@edx/brand/core.min.css';
import '@edx/brand/light.min.css';

const siteConfig: SiteConfig = {
  siteId: 'tutor-site',
  siteName: "Demid Online",
  baseUrl: 'https://apps.demidonline.demid76.ru',
  cmsBaseUrl: 'https://studio.demidonline.demid76.ru',
  lmsBaseUrl: 'https://demidonline.demid76.ru',
  loginUrl: 'https://demidonline.demid76.ru/login',
  logoutUrl: 'https://demidonline.demid76.ru/logout',

  environment: EnvironmentTypes.PRODUCTION,
  apps: [
    shellApp,
    headerApp,
    footerApp,
    customApp,
  ],
  externalRoutes: [],

  runtimeConfigJsonUrl: '/api/frontend_site_config/v1/',
  accessTokenCookieName: 'edx-jwt-cookie-header-payload',
};


addApp(siteConfig, authnApp);



addApp(siteConfig, learnerDashboardApp);



addApp(siteConfig, instructorDashboardApp);



addApp(siteConfig, notificationsApp);

addApp(siteConfig, createLegacyPluginApp({
  appId: 'io.edly.frontend.app.compat.all',
  envConfig: allEnvConfig,
  routeMap,
  slotMap,
  widgetMap,
}));
addApp(siteConfig, createLegacyPluginApp({
  appId: 'io.edly.frontend.app.compat.instructorDashboard',
  envConfig: instructorDashboardEnvConfig,
  mfeId: 'instructor-dashboard',
  routeMap,
  slotMap,
  widgetMap,
}));
addApp(siteConfig, createLegacyPluginApp({
  appId: 'io.edly.frontend.app.compat.notifications',
  envConfig: notificationsEnvConfig,
  mfeId: 'notifications',
  routeMap,
  slotMap,
  widgetMap,
}));




export default siteConfig;